import { createSelector } from 'reselect';
import { updateAccountHeaderSelector } from 'selectors/testTarget/offers/updateAccountHeader/updateAccountHeaderSelector';

/** Returns true when the updateAccountHeader offer's show flag is enabled. */
const showSelector = createSelector(updateAccountHeaderSelector, updateAccountHeader => !!updateAccountHeader.show);

export { showSelector };
